<template>
  <ul class="top-menu nav justify-content-center">
    <li class="nav-item">
      <a
        id="cosaFare"
        class="nav-link"
        href="javascript:void(0)"
        @click="cosaFareNY()"
        >{{ TOP_LINK_COSA_FARE }}</a
      >
    </li>
    <li class="nav-item" v-if="TOP_LINK_CAMBIA_ISOLA !== undefined">
      <a
        id="cambiaIsola"
        class="nav-link"
        href="javascript:void(0)"
        @click="cambiaIsola()"
        >{{ TOP_LINK_CAMBIA_ISOLA }}</a
      >
    </li>
    <li class="nav-item">
      <a
        id="chiSiamo"
        class="nav-link"
        :href="TOP_LINK_CHI_SIAMO_URL"
        target="_blank"
        @click="trackHomeChiSiamo"
        >{{ TOP_LINK_CHI_SIAMO }}</a
      >
    </li>
    <li v-if="!isAuthenticated()" class="nav-item">
      <a class="btn" href="javascript:void(0)" @click="loginAgenzia">{{
        TOP_LINK_AGENZIA
      }}</a>
    </li>
    <li v-else class="nav-item">
      <a class="btn" href="javascript:void(0)" @click="logoutAgenzia"
        >Agenzia {{ token() }} - Logout</a
      >
    </li>
  </ul>
</template>

<script>
import KeycloakLogin from "../../../actions/KeycloakLogin";
import AnalyticEvents from "../../../common/AnalyticEvents";
import ContentUtils from "../../../utils/ContentUtils";

export default {
  name: "TopNavigation",
  mixins: [KeycloakLogin, AnalyticEvents, ContentUtils],
  methods: {
    token() {
      return this.$store.getters.getCodiceAgenzia;
    },
    isAuthenticated() {
      return this.$store.getters.isAuthenticated;
    },
    loginAgenzia() {
      const url = new URL(window.location);
      window.history.pushState({}, "", url);
      this.login();
      this.trackHomeAgenzie();
      this.$emit("click");
    },
    logoutAgenzia() {
      this.logout();
      this.$emit("click");
    },
    cosaFareNY() {
      this.trackHomeCosaFareNy();
      this.$scrollTo("#cosaFareId", 1000);
      this.$emit("click");
    },
    cambiaIsola() {
      this.trackHomeCosaFareNy();
      this.$scrollTo("#cambiaIsolaId", 1000);
      this.$emit("click");
    },
  },
};
</script>



// WEBPACK FOOTER //
// src/front/components/pages/layout/common/TopNavigation.vue